var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _rect2, _rect3, _path25, _path26, _path27, _path28, _path29;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconKawasaki(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "IconKawasaki",
    xmlns: "http://www.w3.org/2000/svg",
    width: 635,
    height: 169.727,
    viewBox: "0 0 635 169.727",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_1588",
    "data-name": "\\u9577\\u65B9\\u5F62 1588",
    width: 635,
    height: 169.727,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11803",
    "data-name": "\\u30D1\\u30B9 11803",
    d: "M148.37,342.72h-5.43v11.62H136.8V321h11.57c8.77,0,12.38,3.47,12.38,11C160.75,338.94,157.19,342.72,148.37,342.72Zm0-16.51h-5.43V337.7h5.43c4.14,0,6.06-1.16,6.06-5.75C154.43,327.59,152.69,326.21,148.37,326.21Z",
    transform: "translate(-102.79 -212.88)",
    fill: "#231815"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11804",
    "data-name": "\\u30D1\\u30B9 11804",
    d: "M177.29,355c-8.28,0-12-4-12-13.93s3.74-14,12-14,11.88,4.09,11.88,14S185.61,355,177.29,355Zm0-4.76c4.4,0,6.05-2.13,6.05-9.17s-1.65-9.17-6.05-9.17-6.14,2.14-6.14,9.17,1.73,9.13,6.14,9.13Z",
    transform: "translate(-102.79 -212.884)",
    fill: "#231815"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11805",
    "data-name": "\\u30D1\\u30B9 11805",
    d: "M214.48,327.55l4.18,18.74.72,3.51h.13l.58-3.56,3.6-18.69h5.52L223,354.34h-7l-3.65-17.27-.67-3.56h-.14l-.71,3.56L207,354.34h-6.94l-6.54-26.79h5.7L203,346.2l.66,3.51h.13l.67-3.51,4.1-18.65Z",
    transform: "translate(-102.79 -212.883)",
    fill: "#231815"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11806",
    "data-name": "\\u30D1\\u30B9 11806",
    d: "M233.87,340.45c0-8.5,3.74-13.35,11.48-13.35,6.59,0,10.82,3.87,10.82,12.42a26.742,26.742,0,0,1-.13,2.71H239.75c.26,5.61,2.62,7.57,7.74,7.57a17.68,17.68,0,0,0,7.21-1.47l.67,4.67a19.47,19.47,0,0,1-8.55,1.83C237.79,354.83,233.87,350.07,233.87,340.45Zm17.09-2c-.09-4.72-2.22-6.5-5.56-6.5-3.87,0-5.52,2-5.79,6.5Z",
    transform: "translate(-103.072 -212.884)",
    fill: "#231815"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11807",
    "data-name": "\\u30D1\\u30B9 11807",
    d: "M264.37,354.34V327.73l4.54-.27.49,5h.13c1.65-3.47,4.41-5.35,7.71-5.35a9.82,9.82,0,0,1,2.8.36l-.36,5.74a9.663,9.663,0,0,0-2.8-.44c-3.87,0-6.85,3-6.85,8.05v13.49Z",
    transform: "translate(-103.134 -212.883)",
    fill: "#231815"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11808",
    "data-name": "\\u30D1\\u30B9 11808",
    d: "M290.1,324c-2.27,0-3.39-.67-3.39-2.63,0-1.73,1.12-2.72,3.39-2.72s3.38,1,3.38,2.72S292.41,324,290.1,324Zm-2.9,30.35V327.73l5.74-.32v26.93Z",
    transform: "translate(-103.176 -212.878)",
    fill: "#231815"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11809",
    "data-name": "\\u30D1\\u30B9 11809",
    d: "M318.58,354.34V337c0-3.39-1.82-4.81-5.12-4.81a6.78,6.78,0,0,0-5.34,2.45v19.67h-5.65V327.68l4-.31.89,2.58a11.09,11.09,0,0,1,7.61-2.89c5.65,0,9.21,3.42,9.21,9.92v17.36Z",
    transform: "translate(-103.219 -212.883)",
    fill: "#231815"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11810",
    "data-name": "\\u30D1\\u30B9 11810",
    d: "M338.17,343c-.9.36-1.43.93-1.43,1.6s.62,1.38,2,1.47l6.46.45c6.36.44,8.63,2.67,8.63,6.63,0,5.16-3.34,8.41-11.88,8.41-7.48,0-10.64-2.94-10.64-7.08a6,6,0,0,1,2.31-4.62,4.42,4.42,0,0,1-2.09-3.83c0-1.78,1.07-3.43,3.34-4.45-1.87-1.21-3.07-3.16-3.07-6.28,0-4.94,2.71-8.19,9.88-8.19a12.4,12.4,0,0,1,6.63,1.56l4.45-1.6,1.2,2.8-3,2.23a8.54,8.54,0,0,1,.54,3.2c0,5.12-2.72,8-9.84,8A18.267,18.267,0,0,1,338.17,343Zm-.41,7.92a4,4,0,0,0-1.6,2.85c0,2.22,1.65,3.43,5.66,3.43,5.51,0,6.89-1.29,6.89-3.21,0-1.51-.84-2.31-4.49-2.58Zm-.4-15.53c0,3.12,1.74,3.92,4.23,3.92,3.47,0,4.49-1.2,4.49-3.92,0-2.89-1.29-3.92-4.36-3.92s-4.36,1.24-4.36,3.91Z",
    transform: "translate(-103.282 -212.953)",
    fill: "#231815"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11811",
    "data-name": "\\u30D1\\u30B9 11811",
    d: "M384.05,354.38l.14-.4-11.62-26.43h6.5l6.63,17.8,1.2,3.38h.1l.89-3.47,5.21-17.71h6.05l-9.47,26.88c-2,5.25-4.81,7.21-9,7.21a10.7,10.7,0,0,1-4.36-.85l.48-4.14a6.3,6.3,0,0,0,2.9.67A4.3,4.3,0,0,0,384.05,354.38Z",
    transform: "translate(-103.374 -212.953)",
    fill: "#231815"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11812",
    "data-name": "\\u30D1\\u30B9 11812",
    d: "M415.33,355c-8.28,0-12-4-12-13.93s3.73-14,12-14,11.89,4.09,11.89,14S423.65,355,415.33,355Zm0-4.76c4.41,0,6.06-2.13,6.06-9.17s-1.65-9.17-6.06-9.17-6.14,2.14-6.14,9.17,1.73,9.13,6.14,9.13Z",
    transform: "translate(-103.438 -212.884)",
    fill: "#231815"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11813",
    "data-name": "\\u30D1\\u30B9 11813",
    d: "M455.29,345.17c0,6.28-3.56,9.66-10.9,9.66s-10.86-3.52-10.86-9.66V327.55h5.65V345c0,3.07,1.69,4.67,5.25,4.67s5.21-1.56,5.21-4.67V327.55h5.65Z",
    transform: "translate(-103.5 -212.884)",
    fill: "#231815"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11814",
    "data-name": "\\u30D1\\u30B9 11814",
    d: "M463.84,354.34V327.73l4.54-.27.49,5H469c1.64-3.47,4.4-5.35,7.7-5.35a9.88,9.88,0,0,1,2.8.36l-.36,5.74a9.661,9.661,0,0,0-2.8-.44c-3.87,0-6.86,3-6.86,8.05v13.49Z",
    transform: "translate(-103.558 -212.883)",
    fill: "#231815"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11815",
    "data-name": "\\u30D1\\u30B9 11815",
    d: "M512.53,354.83a8.77,8.77,0,0,1-6.68-2.49h-.13l.09,3.6v5.08h-5.75V327.73l4-.27,1.11,2.54a10.87,10.87,0,0,1,7.57-2.9c6.59,0,10.19,3.52,10.19,13.8C522.94,350.56,518.89,354.83,512.53,354.83Zm-1.25-22.61a6.43,6.43,0,0,0-5.47,2.63v12.41A5.91,5.91,0,0,0,511.1,350c3.57,0,6-1.69,6-9.13.01-6.82-1.9-8.65-5.82-8.65Z",
    transform: "translate(-103.645 -212.953)",
    fill: "#231815"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11816",
    "data-name": "\\u30D1\\u30B9 11816",
    d: "M540.43,355c-8.28,0-12-4-12-13.93s3.73-14,12-14,11.89,4.09,11.89,14S548.76,355,540.43,355Zm0-4.76c4.41,0,6.05-2.13,6.05-9.17s-1.64-9.17-6.05-9.17-6.14,2.14-6.14,9.17,1.71,9.13,6.14,9.13Z",
    transform: "translate(-103.707 -212.884)",
    fill: "#231815"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11817",
    "data-name": "\\u30D1\\u30B9 11817",
    d: "M566.16,331.91v14.91c0,2.36,1.24,3.34,3.51,3.34a8.112,8.112,0,0,0,2.18-.31l.36,4.22a11.46,11.46,0,0,1-4.19.72c-5,0-7.52-2.9-7.52-7.84v-15h-3.34v-4.36h3.52l1-6.28,4.46-.44v6.72h6.27v4.36Z",
    transform: "translate(-103.756 -212.881)",
    fill: "#231815"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11818",
    "data-name": "\\u30D1\\u30B9 11818",
    d: "M577.28,340.45c0-8.5,3.73-13.35,11.48-13.35,6.59,0,10.82,3.87,10.82,12.42a26.7,26.7,0,0,1-.14,2.71H583.15c.27,5.61,2.63,7.57,7.75,7.57a17.66,17.66,0,0,0,7.2-1.47l.67,4.67a19.43,19.43,0,0,1-8.54,1.83C581.19,354.83,577.28,350.07,577.28,340.45Zm17.09-2c-.09-4.72-2.23-6.5-5.57-6.5-3.87,0-5.51,2-5.78,6.5Z",
    transform: "translate(-103.81 -212.884)",
    fill: "#231815"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11819",
    "data-name": "\\u30D1\\u30B9 11819",
    d: "M622.45,354.34V337c0-3.39-1.83-4.81-5.12-4.81a6.76,6.76,0,0,0-5.34,2.45v19.67h-5.65V327.68l4-.31.89,2.58a11.09,11.09,0,0,1,7.61-2.89c5.65,0,9.21,3.42,9.21,9.92v17.36Z",
    transform: "translate(-103.871 -212.883)",
    fill: "#231815"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11820",
    "data-name": "\\u30D1\\u30B9 11820",
    d: "M642.92,331.91v14.91c0,2.36,1.24,3.34,3.52,3.34a8.112,8.112,0,0,0,2.18-.31l.35,4.22a11.4,11.4,0,0,1-4.18.72c-5,0-7.52-2.9-7.52-7.84v-15h-3.34v-4.36h3.51l1-6.28,4.45-.44v6.72h6.27v4.36Z",
    transform: "translate(-104.11 -212.881)",
    fill: "#231815"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11821",
    "data-name": "\\u30D1\\u30B9 11821",
    d: "M659.79,324c-2.27,0-3.38-.67-3.38-2.63,0-1.73,1.11-2.72,3.38-2.72s3.38,1,3.38,2.72S662.1,324,659.79,324Zm-2.89,30.35V327.73l5.74-.32v26.93Z",
    transform: "translate(-104.11 -212.878)",
    fill: "#231815"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11822",
    "data-name": "\\u30D1\\u30B9 11822",
    d: "M686.08,351.49h-.13a9.43,9.43,0,0,1-7.56,3.34c-5,0-8.28-2.76-8.28-8.73,0-5,3.38-8.28,9.61-8.28a18.461,18.461,0,0,1,5.56.85v-2c0-3.34-1.6-4.68-5.6-4.68a17.151,17.151,0,0,0-7.43,1.51l-.5-4.67a22.12,22.12,0,0,1,9-1.73c7.48,0,10.19,3.2,10.19,10.41v16.87h-4.32Zm-.8-8.94a11.66,11.66,0,0,0-4.53-.76c-3.65,0-5.3,1.47-5.3,4.18,0,3.12,1.87,4.23,4.49,4.23,2.81,0,5.34-1.78,5.34-3.74Z",
    transform: "translate(-104.11 -212.884)",
    fill: "#231815"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11823",
    "data-name": "\\u30D1\\u30B9 11823",
    d: "M699.39,354.34V319.49l5.7-.31v35.16Z",
    transform: "translate(-104.11 -212.879)",
    fill: "#231815"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11824",
    "data-name": "\\u30D1\\u30B9 11824",
    d: "M330.68,44.04h17.05l5.79,19.2,6.03-19.2h14.39l5.54,19.2,6.34-19.2h16.29L389.43,85.01H373.44L367,64.97l-5.65,20.04H344.78Z",
    transform: "translate(-0.773 -0.12)",
    fill: "#e60012"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11825",
    "data-name": "\\u30D1\\u30B9 11825",
    d: "M548.52,283.28h15a6.1,6.1,0,0,0,6.48,6.15c5.26,0,5.15-3.06,5.15-3.06s.11-3.15-5.68-4.06c-6.47-1-20.18-2.13-20.18-13.6,0,0-1.23-14,19.85-14,15,0,20.05,6.58,20.05,14.26H574.91a5.26,5.26,0,0,0-5.39-4.53c-3.14,0-4.89,1.14-4.89,2.61,0,1.9,1.21,2.65,10.06,3.78,10,2.1,15.75,4.62,15.75,15s-10.77,13.78-20.56,13.78S548.52,296.36,548.52,283.28Z",
    transform: "translate(-103.78 -212.719)",
    fill: "#e60012"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11826",
    "data-name": "\\u30D1\\u30B9 11826",
    d: "M608.64,270.67H593.57s-3.19-16.56,22.06-16.56c0,0,18.59-1.05,19.65,13.48s-1.07,24.33,3.3,30.05h-16a18.87,18.87,0,0,1-2.27-3.82s-4.27,5.07-13.42,5.07c-9.34,0-14.54-5.38-14.54-12.26s4-12,16.94-14.29c5.1-.93,9.77-1.58,10-4.36s-3.72-3.4-4.67-3.4C614.55,264.58,608.72,264.18,608.64,270.67Zm1.61,11.52c-3.54,1.53-1.75,4.21-1.75,4.21s1.75,2.93,6,1.84c6.09-1.61,5.6-9.65,5.6-9.65S613.8,280.64,610.25,282.19Z",
    transform: "translate(-103.885 -212.717)",
    fill: "#e60012"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_1589",
    "data-name": "\\u9577\\u65B9\\u5F62 1589",
    width: 16.42,
    height: 11.54,
    transform: "translate(584.56 28.297)",
    fill: "#e60012"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_1590",
    "data-name": "\\u9577\\u65B9\\u5F62 1590",
    width: 16.42,
    height: 40.99,
    transform: "translate(584.56 43.91)",
    fill: "#e60012"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11827",
    "data-name": "\\u30D1\\u30B9 11827",
    d: "M553.69,85.01H537.16V28.31h16.53V53.77l8.33-9.75h19.51L567.1,59.3l16.82,25.71H564.84l-9.07-13.84-2.08,2.28Z",
    transform: "translate(-1.32 -0.088)",
    fill: "#e60012"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11828",
    "data-name": "\\u30D1\\u30B9 11828",
    d: "M232.91,28.34h17.21V45.57l17.24-17.23h21.48L266.9,50.94l23.6,34.07H268.09l-13.52-21.4-4.47,4.63v16.8H232.91Z",
    transform: "translate(-0.531 -0.088)",
    fill: "#e60012"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11829",
    "data-name": "\\u30D1\\u30B9 11829",
    d: "M407.46,270.67H392.54s-3.23-16.56,21.93-16.56c0,0,18.74-1.05,19.77,13.48s-1,24.33,3.27,30.05H421.4a18.458,18.458,0,0,1-2.21-3.82s-4.32,5.07-13.48,5.07-14.43-5.38-14.43-12.26,4-12,16.86-14.29c5.16-.93,9.69-1.58,10-4.36s-3.69-3.4-4.68-3.4C413.44,264.58,407.6,264.18,407.46,270.67Zm1.7,11.52c-3.51,1.53-1.78,4.21-1.78,4.21s1.78,2.93,6,1.84c6.05-1.61,5.56-9.65,5.56-9.65S412.69,280.64,409.16,282.19Z",
    transform: "translate(-103.435 -212.717)",
    fill: "#e60012"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11830",
    "data-name": "\\u30D1\\u30B9 11830",
    d: "M519.19,270.67h-15s-3.25-16.56,21.89-16.56c0,0,18.76-1.05,19.79,13.48s-1,24.33,3.25,30.05H533a24.733,24.733,0,0,1-2.2-3.82s-4.25,5.07-13.39,5.07S503,293.51,503,286.63s4-12,16.76-14.29c5.12-.93,9.8-1.58,9.92-4.36.28-2.85-3.64-3.4-4.64-3.4C525.06,264.58,519.25,264.18,519.19,270.67Zm1.6,11.52c-3.5,1.53-1.75,4.21-1.75,4.21s1.75,2.93,6,1.84c6.06-1.61,5.61-9.65,5.61-9.65S524.32,280.64,520.79,282.19Z",
    transform: "translate(-103.685 -212.717)",
    fill: "#e60012"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11831",
    "data-name": "\\u30D1\\u30B9 11831",
    d: "M187.89,269.29c0-.1,8.48-.19,21.2.88,11.85,1.08,22.83,5.39,25.89,6.62,2.9,1.21,11.26,5.1,11.34,10.88.06,6.36-9.71,10-9.71,10h70.74a20,20,0,0,0-1.75-7.37c-3.27-7.49-12.17-12.47-12.17-12.47a66.53,66.53,0,0,0-24.69-8.35,60.49,60.49,0,0,0,17.66-4.66c9.46-4,15.22-10.1,18-15.11a22.711,22.711,0,0,0,2.91-8.73h-68.8c9.69,4.85,3.89,11.61,3.89,11.61-2.31,2.85-5.4,5.39-11.39,8.4-16.27,7.61-43.15,6.89-43.15,6.89V241H136.8v56.69h51.1V269.3Z",
    transform: "translate(-102.79 -212.688)",
    fill: "#e60012"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKawasaki);
export default __webpack_public_path__ + "static/media/IconKawasaki.3f013e554bf6423ed2c920491f280f58.svg";
export { ForwardRef as ReactComponent };